import React, { FC, useCallback, useMemo, ChangeEvent, useContext } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { Map } from 'immutable'

import {
  EditorState,
  ContentBlock,
  Modifier,
} from 'draft-js'

import EditorContext from './EditorContext'

import {
  getSelectedBlocksList,
} from 'draftjs-utils'

import {
  ITextEditor_EditorUpdate,
  ITextEditor_BlockData,
} from '@kaidam/fc-shared/src/types/texteditor'

const useStyles = makeStyles(theme => ({
  select: {
    fontSize: '0.8em',
    color: theme.palette.grey[800],
  },
}))

interface ToolbarSelectBlockDataProps {
  options: ITextEditor_BlockData[],
  name: string,
  defaultValue: string,
  editorState: EditorState,
  setEditorState: ITextEditor_EditorUpdate,
}

const ToolbarSelectBlockData: FC<React.PropsWithChildren<ToolbarSelectBlockDataProps>> = ({
  options,
  name,
  defaultValue,
  editorState,
  setEditorState,
}) => {

  const editorContext = useContext(EditorContext)
  const classes = useStyles()
  const onChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const useValue = event.target.value as string
    const newContentState = Modifier.mergeBlockData(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      Map().set(name, useValue),
    )
    const newEditorState = EditorState.push(
      editorState,
      newContentState,
      'change-block-data',
    )
    setEditorState(newEditorState)
    setTimeout(() => {
      editorContext.focus()
    }, 0)
  }, [
    editorState,
  ])

  const currentValue = useMemo<string>(() => {
    if(!editorState) return ''
    const blocks = getSelectedBlocksList(editorState) as ContentBlock[]
    const allTypes = blocks.reduce<Record<string, boolean>>((all, block) => {
      const data = block.getData()
      const value = data.get(name)
      if(value) {
        all[value] = true
      }
      return all
    }, {})
    if(Object.keys(allTypes).length != 1) return defaultValue
    return Object.keys(allTypes)[0]
  }, [
    defaultValue,
    editorState,
  ])

  return (
    <FormControl>
      <Select
        className={ classes.select }
        value={ currentValue }
        onChange={ onChange }
        onMouseDown={(e) => e.preventDefault()}
      >
        {
          options.map(option => (
            <MenuItem key={ option.value } value={ option.value }>{ option.title || option.value }</MenuItem>
          ))
        }
      </Select>
    </FormControl>
  )
}

export default ToolbarSelectBlockData